import { render, staticRenderFns } from "./ModalDeleteType.vue?vue&type=template&id=33f9202d&"
import script from "./ModalDeleteType.vue?vue&type=script&lang=js&"
export * from "./ModalDeleteType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports